// extracted by mini-css-extract-plugin
var _1 = "hlwQnh0YcJSUa40pbeom";
export { _1 as "dialog" }
